<script lang="ts">
	import { push } from 'svelte-spa-router';
	import { format } from 'svelte-i18n';
	import { Button, ButtonV2, Container, Modal, Text } from '@Shelly/shelly-design-system';
	import { mobile } from 'src/services/mobile-rework';
	import { createEventDispatcher, onMount } from 'svelte';
	import { save_profile } from 'src/helpers/profile_helpers';
	import { markWhatsNewSeenOnDevice } from 'src/helpers/whats_new_helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let whatsNewDateTimestamp: number | null = null;
	export let showModal = false;
	export let priority = 40;

	$: ButtonComponent = $showNewLayout ? ButtonV2 : Button;

	const dispatch = createEventDispatcher();

	const closeModal = (e: CustomEvent | MouseEvent) => {
		if (showModal) {
			e.preventDefault();
			const seenTimestamp = whatsNewDateTimestamp ?? new Date().getTime() / 1000;
			save_profile('whatsNew', seenTimestamp);
			markWhatsNewSeenOnDevice(seenTimestamp);
			dispatch('close');
		}
	};

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', closeModal);
			return () => mobile.removeEventListener('back_button', closeModal);
		}
	});
</script>

<Modal {showModal} on:close={closeModal} zIndex={priority} hideTitle>
	<Container slot="content" padding="0">
		<div class="d-flex align-items-center flex-direction-column">
			<img class="mb-m" src="./images/spaceship.svg" alt="spaceship" />
			<Text class="mb-s text-center" element="h1"
				>{$format('title_whats_new', { default: 'Shelly Smart Control has been updated' })}</Text
			>
			<Text class="text-center text-color-muted">
				{$format('description_whats_new_changelog', {
					default:
						"We've made some exciting updates to enhance your smart home experience! Check out our changelog to stay up to date with what's new and improved.",
				})}
			</Text>
		</div>
	</Container>

	<div class="d-flex justify-content-end" slot="footer">
		<ButtonComponent
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={(e) => {
				closeModal(e);
				push('/changelog');
			}}
		>
			{$format('tab_changelog', { default: 'Changelog' })}
		</ButtonComponent>

		<ButtonComponent
			on:click={closeModal}
			variant="secondary"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
		>
			{$format('button_close', { default: 'Close' })}
		</ButtonComponent>
	</div>
</Modal>
